import React, { useState, useRef, useContext, createContext, useEffect, useImperativeHandle, forwardRef } from 'react';
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css'; 
import { Layout, Menu, Button, Input} from 'antd';
import { HomeOutlined, AppstoreOutlined, ReloadOutlined, UploadOutlined } from '@ant-design/icons';

import 'antd/dist/reset.css';
import './LoanApp.css';
import ModuleUser from './ModuleUser.jsx';
import ModuleLoan from './ModuleLoan.jsx';
import ModuleSetting from './ModuleSetting';
import ModuleOverview from './ModuleOverview.jsx';
import ModuleLoanState from './ModuleLoanState.jsx';
import ModuleLoanAttr from './ModuleLoanAttr.jsx';
import { LoginRegister, logout, getUser, hasRight, checkAuth} from './Login';
import { waitRef } from './Utils';
import axiosInstance from './axiosInstance.js';

const { Header, Content, Footer } = Layout;
const { Item } = Menu;


const MainContext = createContext(null);


function LoanApp() {
  const [selectedMenu, setSelectedMenu] = useState('loan');
  const [init, setInit] = useState(true);
  const [user, setUser] = useState(null);
  const [version, setVersion] = useState('');
  const appRef = useRef(null);
  const creditRef = useRef(null);
  
  useEffect(() => { 
    checkAuth().then(() => {  setUser(getUser()); setInit(false); console.log('setinit false',init)   })
    axiosInstance.post('appinfo',{}).then((response) => { setVersion(response.data.version)} )
  },[])

  function handleLogin(user) { setUser(user); }
  function handleLogout() { logout(); setUser(null); }
  function handleAssigned() { waitRef(creditRef).then(()=>{creditRef.current.refresh() }) }

  function renderContent() {
      if(init) return ''
      else if(!user) return <LoginRegister logged={handleLogin}/> 
      else return(<>
          {hasRight('users')     && <ModuleUser visible={selectedMenu=='user'}/>}
          {hasRight('settings')  && <ModuleSetting visible={selectedMenu=='settings'}/>} 
          {hasRight('loans')     && <ModuleLoan visible={selectedMenu=='loan'} assigned={handleAssigned} type="0"/>}
          {hasRight('loans')     && <ModuleLoan visible={selectedMenu=='loan1'} type="1"/>}
          {hasRight('loans','W') && <ModuleLoan visible={selectedMenu=='loan2'} type="2"/>}
          {/*hasRight('loans','W') && <ModuleLoan visible={selectedMenu=='loan3'} type="3"/>*/}
          {hasRight('loans','W')     && <ModuleOverview visible={selectedMenu=='overview'} />}
          {/*hasRight('loanstate') && <ModuleLoanState visible={selectedMenu=='loanstate'} />*/}    
          {/*hasRight('loanattr') && <ModuleLoanAttr visible={selectedMenu=='loanattr'} />*/}    
      </>)
  };  

  const items = [
    {key: 'user', label: 'Uživatelé', icon: <AppstoreOutlined />,disabled:!hasRight('users') },
    {key: 'settings', label: 'Nastavení', icon: <AppstoreOutlined />,disabled:!hasRight('settings') },
    {key: 'loan', label: 'Nepřidělené půjčky', icon: <AppstoreOutlined />,disabled:!hasRight('loans') },
    {key: 'loan1', label: 'Přidělené půjčky', icon: <AppstoreOutlined />,disabled:!hasRight('loans') },
    {key: 'loan2', label: 'Vše', icon: <AppstoreOutlined />,disabled:!hasRight('loans','W') },  
    //{key: 'loan3', label: 'Koš', icon: <AppstoreOutlined />,disabled:!hasRight('loans','W') },
    {key: 'overview', label: 'Přehled', icon: <AppstoreOutlined />,disabled:!hasRight('loans','W') },
    //{key: 'loanstate', label: 'Stavy půjček', icon: <AppstoreOutlined />,disabled:!hasRight('loanstate') },
    //{key: 'loanattr', label: 'Atributy půjček', icon: <AppstoreOutlined />,disabled:!hasRight('loanattr') },
  ].filter(e => !e.disabled)



  return (
    <div ref={appRef}>
    <Layout className="layout">
      <Header>
        <div className="logo"><div style={{color:'white',fontSize:20, marginTop:'-18px', marginLeft:'20px'}}>LOANS</div></div>
        { 
        user &&
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Menu
            style={{ flex: 1 }}
            theme="dark"
            mode="horizontal"
            selectedKeys={[selectedMenu]}
            onClick={(e) => setSelectedMenu(e.key)}
            items={items}
          />  
          <div 
            style={{ 
              alignItems: "center",
              display: "flex",
              flexShrink: 0, // Zabraňuje zmenšování
            }}
          >
			      <Credit ref={creditRef}/>
            <span style={{ marginRight: 16, color:'white' }}>Přihlášený uživatel: {user?.name}</span>
            <a onClick={handleLogout} style={{ cursor: 'pointer', color: '#1890ff' }}>Odhlásit</a>
          </div> 
        </div>
        }          
      </Header>
      <Content style={{ padding: '0 16px' }}>
        <div className="site-layout-content" style={{ margin: '16px 0' }}>
          {renderContent()}
        </div>
      </Content>
      
      <Footer className="footer">
        &copy; {new Date().getFullYear()} LIMAsoft | Verze aplikace: {version}
      </Footer>
    </Layout>
    </div>
  );
};


export default LoanApp;



  
const Credit = forwardRef((props,ref) => {
	const [credit,setCredit] = useState(0)
  
	useImperativeHandle(ref, () => ({
    refresh() { task(); }, 
  }))

	function task(){
    try{
      axiosInstance.post('credit',{}).then((response) => { console.log(response.data); setCredit(response.data)} )
    } catch (error) {
      console.error('Error credit', error);
    }
		
    //console.log("credit task run:",new Date().toLocaleTimeString());
	};
	useEffect(() => { 
    task();
    const id = setInterval(task, 10*1000);
		return () => clearInterval(id);
  },[]);

  return (
    <span>
      <span style={{color:'white', marginRight:5}}>Kredit:</span> 
      <Input style={{width:100}} value={credit}/>
      <Button type="primary" icon={<ReloadOutlined/>} style={{marginRight:10}}  onClick={task}/>
	  </span>
  );
})

